import React, { FC } from 'react'

import { BadgeStyled, TBadgeVariant } from './index.style'

interface IProperties {
    children: React.ReactNode
    variant?: TBadgeVariant
    textColor?: string
}

export const Badge: FC<IProperties> = properties => {
    return (
        <BadgeStyled variant={properties.variant || 'primary'} textColor={properties.textColor}>
            {properties.children}
        </BadgeStyled>
    )
}
